import { Component, OnInit, Input } from "@angular/core";

import { BaseComponent, CheckoutService, StorageService, UserService } from "@mypxplat/xplat/core";
import { Router, RouterEvent, NavigationEnd } from "@angular/router";
import moment from "moment";
import { AppService } from "@mypxplat/xplat/web/core";
import { UpdatePaymentSourceStripeComponent } from "../modals";
import { take } from "rxjs";

@Component({
  selector: "myp-missed-payment-notice",
  templateUrl: "missed-payment-notice.component.html",
  standalone: false,
})
export class MissedPaymentNotice extends BaseComponent {
  @Input() missedPaymentDetails: any;

  constructor(
    public storage: StorageService,
    public userService: UserService,
    public appService: AppService,
    public checkoutService: CheckoutService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.userService.getSubscriptionDetails(true).subscribe((result) => {
      if (this.userService.subDetails.subscription.provider == "stripe") {
        this.checkoutService.getCharge(this.missedPaymentDetails.charge).subscribe((result) => {
          this.missedPaymentDetails.charge_data = result;
        });
      }
    });
  }

  goToAddPaymentMethod() {
    window.location.assign("/paymentmethods");
  }
}
